import R from 'ramda';

export default function objectRecord(spec) {
    const filterExtraKeys = R.pick(Object.keys(spec));

    return function(existing = {}, updates = {}) {
        return filterExtraKeys({
            ...spec,
            ...existing,
            ...updates,
        });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/object_record.js